import React, { useEffect, useState } from "react";
import { ArrowBack, Save as SaveIcon } from "@mui/icons-material";
import {
  Box,
  Button,
  TextField,
  Typography,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import api from './api/apiClient';
import NotificationDialog from "./NotificationDialog";

const RoleMaintenance = () => {
  const { roleId } = useParams();
  const navigate = useNavigate();
  const [dialogOpen,setDialogOpen] = useState(false);
  const [severity,setSeverity] = useState("");
  const [message,setMessage] = useState("");
  const [roleName, setRoleName] = useState("");
  const [screens, setScreens] = useState([]);
  const [accessMap, setAccessMap] = useState({});

  useEffect(() => {
    const loadAllData = async () => {    
    fetchScreens();
    if (roleId) {
      fetchRoleDetails();
      fetchRoleAccessData();
    }
  };
  loadAllData();
  }, [roleId]);

  const fetchRoleDetails = async ()=>{
    try{
      let response = await api.get(`/roles/${roleId}`)
      setRoleName(response.data.name)
    }catch(error){
      setDialogOpen(true);
      setSeverity("Error");
      setMessage("Error fetching roles "+error);
      console.log("Error reading Roles")
    }
  }
  const fetchScreens = async () => {
    try {
      let response = await api.get('/screens');
      setScreens(response.data);
    } catch (error) {
      setDialogOpen(true);
      setSeverity("Error");
      setMessage("Error fetching Screens "+error);
      console.error("Error reading screens", error);
    }
  };

  const fetchRoleAccessData = async () => {
    try {
      let response = await api.get(`/rolescreenaccess/${roleId}`);
      console.log("Response from rolecreenaccess is ",response.data);
      const access = {};
      response.data.forEach((entry) => {
        console.log("Access Entry:", entry);
//        access[entry.screenId] = entry.hasAccess;
          access[`${entry.screenId}`] = true;
      });
      console.log("Built Access Map:", access);
      setAccessMap(access);
    } catch (error) {
      setDialogOpen(true);
      setSeverity("Error");
      setMessage("Error fetching Screen access "+error);
      console.error("Error reading role access");
    }
  };

  const handleAccessChange = (screenId) => {
    setAccessMap((prev) => ({
      ...prev,
      [screenId]: !prev[screenId],
    }));
  };
  
  const handleSave = async () => {
    try {
      if (roleId) {
        // Update logic for existing role (edit mode) – implement as needed
        const selectedScreenIds = Object.entries(accessMap)
          .filter(([_, hasAccess]) => hasAccess)
          .map(([screenId]) => screenId);
  
        // Send role name and selected screen IDs to backend
        await api.put(`/roles/update/${roleId}`, {
          name: roleName,
          screenIds: selectedScreenIds,
        });        

      } else {
        // Filter checked screen IDs
        const selectedScreenIds = Object.entries(accessMap)
          .filter(([_, hasAccess]) => hasAccess)
          .map(([screenId]) => screenId);
  
        // Send role name and selected screen IDs to backend
        await api.post(`/roles/create`, {
          name: roleName,
          screenIds: selectedScreenIds,
        });
      }
      setDialogOpen(true);
      setSeverity("Success");
      setMessage("Role Created Successfully!");
      navigate("/roles");
    } catch (error) {
      setDialogOpen(true);
      setSeverity("Error");
      setMessage("Error Creating Role "+ error);
      console.error("Error saving role ", error);
    }
  };
  
  useEffect(() => {
    console.log("Final Access Map:", accessMap);
  }, [accessMap]);
  
  return (
    <Box sx={{ width: "90%", margin: "auto", mt: 5 }}>
      {/* Centered Header */}
{/* Top Action Row with Back & Save */}
<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
  <Box sx={{ display: "flex", gap: 2 }}>
    <Button
      variant="outlined"
      startIcon={<ArrowBack />}
      onClick={() => navigate("/roles")}
    >
      Back
    </Button>
    <Button
      variant="contained"
      startIcon={<SaveIcon />}
      onClick={handleSave}
      disabled={!roleName.trim()}
    >
      Save
    </Button>
  </Box>
  <Typography variant="h5">
    {roleId ? "Edit Role" : "Add Role"}
  </Typography>
</Box>


      {/* Left-aligned Role Name Field */}
      <Box sx={{ maxWidth: 400, mb: 3 }}>
        <TextField
          label="Role Name"
          value={roleName}
          onChange={(e) => setRoleName(e.target.value)}
          fullWidth
        />
      </Box>

      {/* Tabs (placeholder) */}
      <Tabs value={0} sx={{ mb: 2 }}>
        <Tab label="Screen Access" />
      </Tabs>

      {/* Screen Access Table */}
      <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
        <Table stickyHeader size="small" sx={{ minWidth: 400 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ backgroundColor: "#f0f0f0", fontWeight: "bold", border: "1px solid #ccc" }}>
                Screen
              </TableCell>
              <TableCell
                align="center"
                sx={{ backgroundColor: "#f0f0f0", fontWeight: "bold", border: "1px solid #ccc" }}
              >
                Has Access
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {screens.map((screen) => (
              <TableRow key={screen.id} hover sx={{ height: "32px" }}>
                <TableCell sx={{ border: "1px solid #ddd", padding: "4px 8px" }}>
                  {screen.name}
                </TableCell>
                <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                  <Checkbox
                    checked={!!accessMap[`${screen.id}`]}
                    onChange={() => handleAccessChange(`${screen.id}`)}
                    size="small"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Action Buttons */}
      <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={!roleName.trim()}
        >
          Save
        </Button>
        <Button variant="outlined" onClick={() => navigate("/roles")}>
          Cancel
        </Button>
      </Box>
      <NotificationDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        message={message}
        severity={severity}  // other options: "info", "error", "warning"
      />
    </Box>
  );
};

export default RoleMaintenance;
